import script from "./OfficialSite.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficialSite.vue?vue&type=script&setup=true&lang=js"

import "./OfficialSite.vue?vue&type=style&index=0&id=069379e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069379e4"]])

export default __exports__